import { queryOptions, useMutation } from "@tanstack/react-query";
import { getUserId } from "./auth";
import { api } from "./utils";

export const subscriptionsQuery = queryOptions({
  queryKey: ["subscriptions"],
  queryFn: async () => {
    const res = await api.subscriptions.getSubscriptionsForMember({ memberId: getUserId(), includeInactive: false });
    return res.subscriptions;
  },
});

export const subscriptionQuery = (subscriptionId: string) =>
  queryOptions({
    queryKey: ["subscriptions", subscriptionId],
    queryFn: async () => {
      const res = await api.subscriptions.getSubscriptionsForMember({ memberId: getUserId(), includeInactive: false });
      const subscription = res.subscriptions.find(s => s.subscription_id === subscriptionId);
      return subscription || null;
    },
  });

export function useCancelSubscriptionMutation() {
  return useMutation({
    mutationFn: async (subscriptionId: string) => {
      await api.subscriptions.cancelSubscriptionAsMember({ subscriptionId });
    },
  });
}
